export function removeSession() {
  localStorage.removeItem("BSRM_USER");
  localStorage.removeItem("product-type");
  localStorage.removeItem("dynamic");
  localStorage.clear();
}
